export class PasswordChanged {
  constructor() {}
}
